export default __webpack_public_path__ + "static/media/coffee_guy.a7d028f1.jpg";